export const light_navy = "#12365b";
export const ionev_blue = "#5797b6";
export const ionev_green = "#35a67d";
export const ionev_red = "#e75858";
export const bluish = "#259cc4";
export const ionev_light_grey = "#f5f5f5";
export const white_two = "#ffffff";
export const battleship_grey = "#74787d";
export const medium_grey = "#828b94";
export const ice_blue = "#eef1f2";